/*:: type integrationId = string;*/

const PagedList = require('../entities/paged-list');

const Integration = require('../entities/integration');

const {
  strinct
} = require('../utils/serialize');

const AccessContext = require('./contexts/access-context');

const TagsRepo = require('./tags-repo');

const TYPE_NAME = TagsRepo.TYPE_NAMES.integration;
const fields = ['id', 'name', 'target', 'writeKey', 'scope', 'corsOrigins', 'lifespan'];
const searchFields = ['id', 'name', 'target', 'tags.name', 'writeKey'];

class IntegrationRepo {
  constructor(client
  /*: ApiClient*/
  , id
  /*: integrationId*/
  , context
  /*: AccessContext*/
  ) {
    this.client = client;
    this.id = id;
    this.context = context;
  }

  getTags()
  /*: (Promise<any>)*/
  {
    const {
      propertyId
    } = this.context.serialize();
    return this.client.tags.list(propertyId, TYPE_NAME, this.id);
  }

  updateTags(newTags
  /*: Array<string>*/
  )
  /*: (Promise<any>)*/
  {
    const {
      propertyId
    } = this.context.serialize();
    return this.client.tags.reconcile(propertyId, TYPE_NAME, this.id, newTags);
  }

  details()
  /*: (Promise<Integration>)*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const path = propertyId ? `/properties/${propertyId}/integrations/${this.id}` : `/businesses/${businessId}/integrations/${this.id}`;
    const req = new this.client.Request(path, {}, fields);
    req.parse = Integration.parse;
    return this.client.get(req);
  }

  update(updates
  /*: Integration | Object*/
  ) {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const path = propertyId ? `/properties/${propertyId}/integrations/${this.id}` : `/businesses/${businessId}/integrations/${this.id}`;
    const req = new this.client.Request(path, updates, fields);
    req.parse = Integration.parse;
    req.serialize = Integration.serialize;
    return this.client.patch(req);
  }

  delete()
  /*: (Promise<boolean>)*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const path = propertyId ? `/properties/${propertyId}/integrations/${this.id}` : `/businesses/${businessId}/integrations/${this.id}`;
    return this.client.delete(new this.client.Request(path));
  }

}

class IntegrationsRepo {
  constructor(client
  /*: ApiClient*/
  , context
  /*: AccessContext*/
  ) {
    this.context = context;
    this.client = client;

    this.for = (id
    /*: integrationId*/
    ) => new IntegrationRepo(client, id, this.context);

    this.icanhas = this.for;
  }

  list()
  /*: (Promise<Array<Integration>>)*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const path = propertyId ? `/properties/${propertyId}/integrations` : `/businesses/${businessId}/integrations`;
    return this.client.get(new this.client.Request(path, {}, fields));
  }

  create(instance
  /*: Integration*/
  )
  /*: (Promise<Integration>)*/
  {
    if (instance.id != null) throw new Error('Object already has id');
    if (!instance.corsDomains) throw new Error('Integration missing required parameter corsDomains: Array<string>');
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const path = propertyId ? `/properties/${propertyId}/integrations` : `/businesses/${businessId}/integrations`;
    const req = new this.client.Request(path, instance, fields);
    req.parse = Integration.parse;
    req.serialize = Integration.serialize;
    return this.client.post(req);
  }

  search({
    /*: { query?: string, fields?: Array<string> }*/

    query,
    fields: customFields
  })
  /*: Promise<PagedList<Integration>>*/
  {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const path = propertyId ? `/properties/${propertyId}/integrations/search` : `/businesses/${businessId}/integrations/search`;
    const req = new this.client.Request(path, {
      q: strinct(query)
    }, customFields || searchFields);
    return this.client.get(req);
  }

}

module.exports = IntegrationsRepo;